export const PERKS_STEP_TYPE = 'CreateTier'
export const POST_STEP_TYPE = 'CreatePost'
export const LINK_TO_HOMEPAGE_STEP_TYPE = 'LinkToMembership'
